import React, { useState } from "react";
import {
  Box,
  Toolbar,
  List,
  ListItem,
  IconButton,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import SourceIcon from "@mui/icons-material/Source";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import "./flowbuilderpannel.css";

const drawerWidth = 300;

const openedMixin = (theme) => ({
  position: "relative",
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  background: "#111111",
  borderRadius: "5px",
});

const closedMixin = (theme) => ({
  position: "relative",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  background: "#111111",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ processType }) => {
  const onDragStart = (event, nodeType, nodeValue, className) => {
    event.dataTransfer.setData("application/reactflow", nodeType);
    event.dataTransfer.setData("nodeName", nodeValue);
    event.dataTransfer.setData("className", className);
    event.dataTransfer.effectAllowed = "move";
  };

  const [open, setOpen] = useState(false);

  const menuList = [
    {
      id: 2,
      text: "Read",
      value: "read",
      icon: <TextSnippetIcon fontSize="small" />,
    },
    {
      id: 2,
      text: "Preprocess",
      value: "preprocess",
      icon: <TextSnippetIcon fontSize="small" />,
    },
    {
      id: 3,
      text: "Instrument",
      value: "instrument",
      icon: <AccountTreeIcon fontSize="small" />,
    },
    {
      id: 4,
      text: "Data Transform",
      value: "data-transform",
      icon: <AutorenewIcon fontSize="small" />,
    },
    {
      id: 5,
      text: "Write",
      value: "write",
      icon: <DriveFileRenameOutlineIcon fontSize="small" />,
    },
    {
      id: 6,
      text: "Data Quality",
      value: "data-quality",
      icon: <SourceIcon fontSize="small" />,
    },
    {
      id: 6,
      text: "Sql_Connector",
      value: "Sql_Connector",
      icon: <SettingsSuggestIcon fontSize="small" />,
    },
  ];

  const filteredMenuList =
    processType === "data-ingestion"
      ? menuList.filter(
          (item) => item.value === "preprocess" || item.value === "write"
        )
      : processType === "data-quality"
      ? menuList.filter(
          (item) => item.value === "data-quality" || item.value === "write"
        )
      : processType === "data-transformation"
      ? menuList.filter(
          (item) =>
            item.value === "read" ||
            item.value === "instrument" ||
            item.value === "data-transform" ||
            item.value === "write" ||
            item.value === "Sql_Connector"
        )
      : menuList;

  const [type, setType] = useState(filteredMenuList[0]?.text);

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  const handleList = (type) => {
    setType(type);
  };

  return (
    <>
      <Box className="custom-scrollbar">
        <AppBar
          position="absolute"
          open={open}
          sx={{
            background: "#111111",
            width: "14px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "12vh",
            borderTopRightRadius: "12px",
            borderBottomRightRadius: "12px",
            left: open ? "-3.8px" : "57px",
            top: `calc(100% - 40vh)`,
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              size="small"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
            >
              {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open} sx={{ height: "100%" }}>
          <Box
            className="custom-scrollbar"
            sx={{
              display: "flex",
              position: "relative",
              height: "90%",
              background: "#111111",
              borderRadius: "5px",
            }}
          >
            <List>
              {filteredMenuList.map((item) => (
                <ListItem
                  key={item.id}
                  disablePadding
                  sx={{ display: "flex", my: "3px" }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      whiteSpace: "break-spaces",
                      textAlign: "center",
                      "&.Mui-selected": {
                        background: "#4a4e69",
                        height: "65px",
                        width: "80px",
                        maxWidth: "95px",
                        borderRadius: "3px",
                        "&:hover": { backgroundColor: "#4a4e69" },
                        ".MuiListItemIcon-root, .MuiListItemText-root": {
                          color: "#fff",
                        },
                      },
                    }}
                    selected={type === item.text}
                    onClick={() => handleList(item.text)}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 0.5 : "auto",
                        color: "#696969",
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.text}
                      sx={{ opacity: open ? 1 : 0, color: "#696969" }}
                      primaryTypographyProps={{
                        fontSize: 12,
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                height: "78vh",
                display: "flex",
                flexWrap: "wrap",
                overflowY: "auto",
                alignContent: "flex-start",
                py: 1,
                minWidth: "200px",
              }}
            >
              {processType === "data-ingestion" && type === "Preprocess" && (
                <div
                  className="dndnode input"
                  onDragStart={(event) =>
                    onDragStart(
                      event,
                      "editableNode",
                      "PREPROCESS_INSTRUMENT_FILE",
                      "dndnode input"
                    )
                  }
                  draggable
                >
                  <div className="node-container">
                    Prepocess Instrument File
                  </div>
                </div>
              )}
              {processType === "data-transformation" && type === "Read" && (
                <>
                  <div
                    className="dndnode input"
                    onDragStart={(event) =>
                      onDragStart(
                        event,
                        "editableNode",
                        "ReadCSV",
                        "dndnode input"
                      )
                    }
                    draggable
                  >
                    <div className="node-container">Read Spreadsheets</div>
                  </div>
                  <div
                    className="dndnode input"
                    onDragStart={(event) =>
                      onDragStart(
                        event,
                        "editableNode",
                        "ReadPostgres",
                        "dndnode input"
                      )
                    }
                    draggable
                  >
                    <div className="node-container">Read Postgres</div>
                  </div>
                  {/* <div
                    className="dndnode input"
                    onDragStart={(event) =>
                      onDragStart(
                        event,
                        "editableNode",
                        "ReadBenchlingPostgres",
                        "dndnode input"
                      )
                    }
                    draggable
                  >
                    <div className="node-container">
                      Read Benchling Postgres
                    </div>
                  </div> */}
                  {/* <div
                    className="dndnode input"
                    onDragStart={(event) =>
                      onDragStart(
                        event,
                        "editableNode",
                        "ReadOracle",
                        "dndnode input"
                      )
                    }
                    draggable
                  >
                    <div className="node-container">Read Oracle</div>
                  </div> */}
                </>
              )}
              {processType === "data-transformation" &&
                type === "Instrument" && (
                  <>
                    <div
                      className="dndnode input"
                      onDragStart={(event) =>
                        onDragStart(
                          event,
                          "editableNode",
                          "Instrument",
                          "dndnode input"
                        )
                      }
                      draggable
                    >
                      <div className="node-container">Instrument</div>
                    </div>
                  </>
                )}
              {processType === "data-transformation" &&
                type === "Data Transform" && (
                  <>
                    <div
                      className="dndnode input"
                      onDragStart={(event) =>
                        onDragStart(
                          event,
                          "editableNode",
                          "ExecuteSQL",
                          "dndnode input"
                        )
                      }
                      draggable
                    >
                      <div className="node-container">ExecuteSQL</div>
                    </div>
                    <div
                      className="dndnode input"
                      onDragStart={(event) =>
                        onDragStart(
                          event,
                          "editableNode",
                          "Sort",
                          "dndnode input"
                        )
                      }
                      draggable
                    >
                      <div className="node-container">Sort</div>
                    </div>
                    <div
                      className="dndnode input"
                      onDragStart={(event) =>
                        onDragStart(
                          event,
                          "editableNode",
                          "Filter",
                          "dndnode input"
                        )
                      }
                      draggable
                    >
                      <div className="node-container">Filter</div>
                    </div>
                    <div
                      className="dndnode input"
                      onDragStart={(event) =>
                        onDragStart(
                          event,
                          "editableNode",
                          "Join",
                          "dndnode input"
                        )
                      }
                      draggable
                    >
                      <div className="node-container">Join</div>
                    </div>
                  </>
                )}
              {type === "Write" && (
                <>
                  <div
                    className="dndnode input"
                    onDragStart={(event) =>
                      onDragStart(
                        event,
                        "editableNode",
                        "Write",
                        "dndnode input"
                      )
                    }
                    draggable
                  >
                    <div className="node-container">Write S3</div>
                  </div>
                  <div
                    className="dndnode input"
                    onDragStart={(event) =>
                      onDragStart(
                        event,
                        "editableNode",
                        "Ingestion Write",
                        "dndnode input"
                      )
                    }
                    draggable
                  >
                    <div className="node-container">Ingestion Write S3</div>
                  </div>
                  <div
                    className="dndnode input"
                    onDragStart={(event) =>
                      onDragStart(
                        event,
                        "editableNode",
                        "WriteToBenchling",
                        "dndnode input"
                      )
                    }
                    draggable
                  >
                    <div className="node-container">Benchling Write</div>
                  </div>
                  <div
                    className="dndnode input"
                    onDragStart={(event) =>
                      onDragStart(
                        event,
                        "editableNode",
                        "WriteToPostgres",
                        "dndnode input"
                      )
                    }
                    draggable
                  >
                    <div className="node-container">Postgres Write</div>
                  </div>
                </>
              )}
              {processType === "data-quality" && type === "Data Quality" && (
                <>
                  <div
                    className="dndnode input"
                    onDragStart={(event) =>
                      onDragStart(
                        event,
                        "editableNode",
                        "Source",
                        "dndnode input"
                      )
                    }
                    draggable
                  >
                    <div className="node-container">Source</div>
                  </div>

                  <div
                    className="dndnode input"
                    onDragStart={(event) =>
                      onDragStart(
                        event,
                        "editableNode",
                        "DataValidation",
                        "dndnode input"
                      )
                    }
                    draggable
                  >
                    <div className="node-container">Validation</div>
                  </div>
                </>
              )}
              {processType === "data-transformation" &&
                type === "Sql_Connector" && (
                  <>
                    <div
                      className="dndnode input"
                      onDragStart={(event) =>
                        onDragStart(
                          event,
                          "editableNode",
                          "Sql_Connector",
                          "dndnode input"
                        )
                      }
                      draggable
                    >
                      <div className="node-container">Sql Connector</div>
                    </div>
                  </>
                )}
            </Box>
          </Box>
        </Drawer>
      </Box>
    </>
  );
};
